import { lazy } from "react";
import Loadable from "app/components/Loadable";

const BorrowerInfo = Loadable(lazy(() => import("./BorrowerInfo")));

const borrowerinfoRoute = [{ path: "/borrower-information", element: <BorrowerInfo /> }];
export default borrowerinfoRoute;
